import React from "react";
import Breadcrumb from "./components/Breadcrumb";
import { useParams } from "react-router-dom";
import DestinationTab from "./components/DestinationTab";
import useFetch from "../../commons/useFetch/index";
import Banner from "./components/Banner";
import { BookingComponent } from "../../components";

function DestinationDetail() {
  const { id,hastag } = useParams();
  const { data: destinations } = useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/destinations/' + id);
  return (
    <div id="destinationDetail" className=" detailPage">
      {destinations && <Banner destinations={destinations} />}
      <BookingComponent />
      {destinations && <Breadcrumb destinations={destinations} />}
      {destinations && (
        <DestinationTab destinations={destinations}  id={id} hastag={hastag}/>
      )}
    </div>
  );
}
export default DestinationDetail;
